'use client';

import { useEffect, useState } from 'react';
import Script from 'next/script';
import { buildGaInitScript } from '@/shared/lib/analytics/gaPaths';
import {
  COOKIE_CONSENT_EVENT,
  readCookieConsent,
} from '@/shared/lib/privacy/cookieConsent';

const ConsentManagedAnalytics = ({ gaId }: { readonly gaId?: string }) => {
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const syncConsent = () => {
      const nextIsAllowed = readCookieConsent()?.analytics === true;
      if (gaId) {
        (window as unknown as Record<string, boolean>)[`ga-disable-${gaId}`] =
          !nextIsAllowed;
      }
      setIsAllowed(nextIsAllowed);
    };
    syncConsent();
    window.addEventListener(COOKIE_CONSENT_EVENT, syncConsent);
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, syncConsent);
  }, [gaId]);

  if (!gaId || !isAllowed) return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {buildGaInitScript(gaId)}
      </Script>
    </>
  );
};

export default ConsentManagedAnalytics;
